import NavbarMobile from './NavbarMobile';
import NavbarDesktop from './NavbarDesktop';
import Banner from './Banner';
import Intro from './Intro';
import Instructions from './Instructions';
import Demo from './Demo';
import Components from './Components';
import Pricing from './Pricing';
import Contact from './Contact';
import Footer from './Footer';


const HomePage = () => {

    return (

        <>

            <NavbarMobile />

            <NavbarDesktop />

            <Banner />

            <Intro />

            <Instructions />

            <Demo />

            <Components />

            <Pricing />

            <Contact />

            <Footer />

        </>

    )
}

export default HomePage;